/**
 * @private
 * @sw-package fundamentals@after-sales
 */
Shopware.Component.extend(
    'swag-migration-profile-shopware54-api-credential-form',
    'swag-migration-profile-shopware-api-credential-form',
    {},
);
